import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {UserProfileCardProps} from '../type';
import DesktopView from './DesktopView';
import MobileView from './MobileView';

export default (props: UserProfileCardProps) => {
  const isLarge = useIsLargeDevice();
  return isLarge || props.mode === 'RECRUITER' ? (
    <DesktopView {...props} />
  ) : (
    <MobileView {...props} />
  );
};
